import { gql } from "@apollo/client"

const SENSOR_MOBILE_LOCATION_FIELDS = gql`
  fragment SensorMobileLocationFields on SensorMobileLocation {
    mobileCountryCode
    mobileNetworkCode
    locationAreaCode
    cellId
  }
`

const SENSOR_GATEWAY_FIELDS = gql`
  fragment SensorGatewayFields on SensorGateway {
    id
    deviceIdentifier
    name
    product
    isOnline
    lastSeenAt
  }
`

const SENSOR_FIELDS = gql`
  fragment SensorFields on Sensor {
    id
    serial
    name
    type
    product
    location {
      id
    }
    sample {
      id
      value
      battery
      signal
      at
      type
      lbs {
        ...SensorMobileLocationFields
      }
      displayUnit
      probeValue
      probeAt
    }
    samples {
      id
      value
      battery
      signal
      at
      type
      lbs {
        ...SensorMobileLocationFields
      }
      displayUnit
    }
  }
  ${SENSOR_MOBILE_LOCATION_FIELDS}
`

const SENSOR_DETAIL_FIELDS = gql`
  fragment SensorDetailFields on SensorDetail {
    id
    serial
    name
    type
    product
    location {
      id
    }
    sample {
      id
      value
      battery
      signal
      at
      type
      displayUnit
      probeValue
      probeAt
    }
    samples {
      id
      value
      battery
      signal
      at
      type
      lbs {
        ...SensorMobileLocationFields
      }
      displayUnit
      channel
    }
    capabilities {
      canNameChange
      canListRules
      canCreateRules
      canUpdateRules
      canDeleteRules
    }
  }
  ${SENSOR_MOBILE_LOCATION_FIELDS}
`

const SENSOR_DEVICE_FIELDS = gql`
  fragment SensorDeviceFields on SensorDevice {
    ... on Sensor {
      id
      serial
      name
      type
      product
      location {
        id
        name
      }
      sample {
        id
        value
        battery
        signal
        at
        type
        lbs {
          ...SensorMobileLocationFields
        }
        displayUnit
        probeValue
        probeAt
      }
      samples {
        id
        value
        battery
        signal
        at
        type
        lbs {
          ...SensorMobileLocationFields
        }
        displayUnit
      }
    }
    ... on SensorGateway {
      ...SensorGatewayFields
    }
  }
  ${SENSOR_GATEWAY_FIELDS}
  ${SENSOR_MOBILE_LOCATION_FIELDS}
`

export { SENSOR_FIELDS, SENSOR_MOBILE_LOCATION_FIELDS, SENSOR_DETAIL_FIELDS, SENSOR_DEVICE_FIELDS }
